import dataItemStyle from '@/services/compiler-refactor/xmlConvert/dataItemStyle';

export const getValue = (
  name: string,
  watchfaceCapabilityList: string[],
  capabilitySetJson: any
) => {
  if (!watchfaceCapabilityList.length) return;
  const capabilityKeys = Object.keys(capabilitySetJson);
  let curCapabilityList: any[] = [];
  const valueList: any[] = [];
  for (const key of capabilityKeys) {
    if (name === capabilitySetJson[key].name)
      curCapabilityList = capabilitySetJson[key].list;
  }
  if (name === 'data_source') {
    watchfaceCapabilityList.map((capa) => {
      const capaUid = dataItemStyle[capa].toString(16);
      const findCapability = curCapabilityList.find(
        (item: any) => item.uid === capaUid
      );
      if (findCapability) valueList.push(findCapability.value);
    });
  } else {
    watchfaceCapabilityList.map((capa) => {
      const findCapability = curCapabilityList.find(
        (item: any) => item.comment === capa
      );
      if (findCapability) valueList.push(findCapability.value);
    });
  }
  valueList.sort((a, b) => a - b);
  return valueToBits(valueList);
};

const valueToBits = (valueList: number[]) => {
  let bit = 0;
  let count = 1;
  const bitsList: string[] = [];
  valueList.map((value) => {
    // js无法正确处理1的31位左移，左移后为负数，需要加绝对值
    if (value < count * 32) bit += Math.abs(1 << (value - (count - 1) * 32));
    else if (value >= (count + 1) * 32) {
      const bitStr = reverseStr(bit.toString(2).padStart(32, '0'));
      // 当value大于(count+1)*32时，需要跳过count*32个0bit
      bitsList.push(bitStr);
      bit = 0;
      const jumpCount = Math.floor(value / 32) - count;
      for (let i = 0; i < jumpCount; i++) {
        const bitStr = reverseStr(bit.toString(2).padStart(32, '0'));
        bitsList.push(bitStr);
      }
      count += jumpCount + 1;
      bit += 1 << (value - count * 32);
    } else {
      const bitStr = reverseStr(bit.toString(2).padStart(32, '0'));
      bitsList.push(bitStr);
      bit = 0 + (1 << (value - count * 32));
      count++;
    }
  });
  bitsList.push(reverseStr(bit.toString(2)));
  const bitStr = bitsList.join(',');
  return [bitStr];
};

const reverseStr = (str: string) => {
  return str.split('').reverse().join('');
};
